import {
  User, Briefcase, GraduationCap, Wrench, Globe, Heart,
  FolderOpen, Award, Users, FileText
} from 'lucide-react';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STEPS = [
  { id: 'personal', label: 'Informations', icon: User, color: '#0D9488' },
  { id: 'experience', label: 'Expérience', icon: Briefcase, color: '#0F766E' },
  { id: 'education', label: 'Formation', icon: GraduationCap, color: '#14B8A6' },
  { id: 'skills', label: 'Compétences', icon: Wrench, color: '#F59E0B' },
  { id: 'languages', label: 'Langues', icon: Globe, color: '#0D9488' },
  { id: 'interests', label: "Centres d'intérêt", icon: Heart, color: '#D97706' },
  { id: 'projects', label: 'Projets', icon: FolderOpen, color: '#0F766E' },
  { id: 'certifications', label: 'Certifications', icon: Award, color: '#14B8A6' },
  { id: 'références', label: 'Références', icon: Users, color: '#F59E0B' },
  { id: 'preview', label: 'Aperçu', icon: FileText, color: '#0D9488' },
];

export const TEMPLATES = [
  { id: 'classique', name: 'Classique', desc: 'Design professionnel et sobre' },
  { id: 'moderne', name: 'Moderne', desc: 'Design contemporain avec couleurs' },
  { id: 'creatif', name: 'Creatif', desc: 'Design original et distinctif' },
];

export const SKILL_LEVELS = ['Débutant', 'Intermédiaire', 'Avancé', 'Expert'];
export const LANG_LEVELS = ['Notions', 'Intermédiaire', 'Courant', 'Bilingue', 'Langue maternelle'];

export const EMPTY_CV = {
  personal: { firstName: '', lastName: '', email: '', phone: '', address: '', city: '', zip: '', country: 'Polynésie française', summary: '' },
  experiences: [],
  education: [],
  skills: [],
  languages: [],
  interests: [],
  projects: [],
  certifications: [],
  références: [],
};

export const LS_KEY = 'aerh_cv_draft';

export const TONES = [
  { id: 'professionnel', label: 'Professionnel' },
  { id: 'dynamique', label: 'Dynamique' },
  { id: 'creatif', label: 'Creatif' },
  { id: 'formel', label: 'Formel' },
];

export const fmtDate = (d) => d ? new Date(d + '-01').toLocaleDateString('fr-FR', { month: 'short', year: 'numeric' }) : '';
